import React from 'react';
import styled from 'styled-components';

const F5Style = styled.svg``;

export const F5 = ({ color }) => {
	return (
		<F5Style
			xmlns='http://www.w3.org/2000/svg'
			width='22.268'
			height='23.592'
			viewBox='0 0 22.268 23.592'
		>
			<path
				id='toast'
				d='M852.713,521.56a.513.513,0,0,1,.656-.309.519.519,0,0,1,.309.662l-.489,1.336a.515.515,0,1,1-.967-.358l.49-1.331Zm-2.407,10.123h4.955a15.194,15.194,0,0,0-2.515-3.583l-2.783,1.2a14.962,14.962,0,0,0,.344,2.381Zm5.417,1.034h-5.15a14.163,14.163,0,0,0,.687,1.835,3.449,3.449,0,0,0,2.592,2.284,1.954,1.954,0,0,0,1.732-.753,3.4,3.4,0,0,0,.139-3.366Zm-12.543-4.339h4.984l.015-.06a15.062,15.062,0,0,0,.353-2.43l-2.783-1.2a15.159,15.159,0,0,0-2.57,3.695Zm4.708,1.033h-5.159a3.34,3.34,0,0,0,.183,3.252,1.946,1.946,0,0,0,1.735.753,3.45,3.45,0,0,0,2.589-2.279,13.742,13.742,0,0,0,.653-1.726Zm-1.951-6.513,3.81,1.652a.865.865,0,0,1,.517.8,16.216,16.216,0,0,1-.174,2.041l2.467-1.075a.857.857,0,0,1,.984.151,16.572,16.572,0,0,1,3.737,5.518,5.077,5.077,0,0,1-.343,5.14,4.085,4.085,0,0,1-.7.693L858.054,542l1.135-.486a.849.849,0,0,1,1.121.438.862.862,0,0,1-.444,1.13l-3.837,1.66a.858.858,0,0,1-1.121-.444.849.849,0,0,1,.447-1.118l1.133-.5-1.817-4.185a3.733,3.733,0,0,1-.975.035,5.064,5.064,0,0,1-3.99-3.262,16.061,16.061,0,0,1-1.052-3.142,4.947,4.947,0,0,1-3.859,2.984,3.222,3.222,0,0,1-.971-.037l-1.817,4.193,1.132.492a.85.85,0,1,1-.674,1.562l-3.837-1.664a.851.851,0,1,1,.675-1.562l1.135.492,1.817-4.193a3.575,3.575,0,0,1-.7-.687,5.061,5.061,0,0,1-.344-5.135,16.51,16.51,0,0,1,3.733-5.517.855.855,0,0,1,.984-.158Zm9.735.608a.508.508,0,0,1,.68.242.515.515,0,0,1-.249.687l-1.288.6a.519.519,0,0,1-.681-.255.511.511,0,0,1,.247-.681l1.291-.595Zm-6.435-1.446a.516.516,0,0,1,.249-.681.509.509,0,0,1,.683.249l.6,1.288a.514.514,0,1,1-.932.432l-.6-1.288Z'
				transform='translate(-838.115 -521.22)'
				fill={color}
			/>
		</F5Style>
	);
};
